import React from 'react'
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer';
import CourseIntro from './CourseIntro';

const CourseDetails = () => {
  return (
    <>
    
    <Navbar />
    

    <CourseIntro />


    
    <Footer />
    
    </>
  )
}

export default CourseDetails;